<template>
  <div
    class="pdf-wrap"
    :style="{ transform: `scale(1)` }"
    :class="{ full: isFullscreen }"
  >
    <pdf
      ref="pdf"
      :src="pdfPath"
      :page="currentPage"
      @num-pages="pageCount = $event"
      @page-loaded="currentPage = $event"
      class="pdf"
    ></pdf>
    <div class="vue-pdf-embed">
      <div class="page-tool">
        <div class="page-tool-item" @click="previousPage">
          <a>上一页</a>
        </div>
        <div class="page-tool-item" @click="nextPage">
          <a>下一页</a>
        </div>
        <div class="page-tool-item">{{ currentPage }}/{{ pageCount }}</div>
        <div class="page-tool-item" @click="pageZoomOut">
          <a>放大</a>
        </div>
        <div class="page-tool-item" @click="pageZoomIn">
          <a>缩小</a>
        </div>
        <div class="page-tool-item" @click="pageOriginalSize">
          <a>自适应</a>
        </div>
        <div class="page-tool-item" @click="fullScreen">
          <a>全屏</a>
        </div>
      </div>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="420px"
      :modal-append-to-body="false"
      :append-to-body="false"
      top="35vh"
      custom-class="pdf-dialog"
    >
      <span v-show="firstOrLast === '1'">该章节第一页，是否进入上一篇？</span>
      <span v-show="firstOrLast === '2'">该章节最后一页，是否进入下一篇？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          v-show="firstOrLast === '1'"
          type="primary"
          :autofocus="true"
          @click="handleFirstNode"
          >上一篇</el-button
        >
        <el-button
          v-show="firstOrLast === '2'"
          type="primary"
          :autofocus="true"
          @click="handleLastNode"
          >下一篇</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import screenfull from "screenfull";
import pdf from "vue-pdf";
// import PDFJS from 'pdfjs-dist'

export default {
  name: "PdfViewer",
  components: { pdf },
  props: {
    pdfPath: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 1,
      scale: 100,

      isFullscreen: false,
      firstOrLast: undefined, // 1 : 2
      dialogVisible: false,
    };
  },
  watch: {
    pdfPath(val) {
      if (val) {
        this.currentPage = 1;
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
  },

  created() {
    let _this = this;
    document.onkeydown = function (e) {
      let evn = e || event;
      let key = evn.keyCode || evn.which || evn.charCode;

      // 左
      if (key === 37) {
        if (!_this.dialogVisible) {
          _this.previousPage();
        }
      }
      // 右
      if (key === 39) {
        if (!_this.dialogVisible) {
          _this.nextPage();
        }
      }
      //回车键
      if (key === 13) {
        if (_this.dialogVisible) {
          if (_this.firstOrLast === "1") {
            _this.handleFirstNode();
          } else if (_this.firstOrLast === "2") {
            _this.handleLastNode();
          }
        }
      }
    };
  },
  methods: {
    // 上一页
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      } else if (this.currentPage === 1) {
        this.firstOrLast = "1";
        this.dialogVisible = true;
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage += 1;
      } else if (this.currentPage === this.pageCount) {
        // if (screenfull.isFullscreen) {
        //   screenfull.exit();
        // }
        this.firstOrLast = "2";
        this.dialogVisible = true;
      }
    },
    pageZoomOut() {
      //this.scale = Number((this.scale + 0.1).toFixed(1));

      // if (this.scale < 150) {
      this.scale += 10;

      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      //   //transform:scale(${state.scale})
      // }
    },
    pageZoomIn() {
      //this.scale = Number((this.scale - 0.1).toFixed(1));

      if (this.scale > 10) {
        this.scale -= 10;

        this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      }
    },
    pageOriginalSize() {
      this.scale = 100;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
    },
    fullScreen() {
      let index = 0;
      this.$refs.pdf.pdf.forEachPage((page) => {
        index++;
        if (index === this.currentPage) {
          var viewport = page.getViewport({ scale: 1 });
          // console.log(
          //   viewport.width,
          //   viewport.height,
          //   screen.width,
          //   screen.height
          // );
          //console.log((viewport.width / viewport.height), (screen.width / screen.height));
          // 高度大于宽度 || 宽高比例低于屏幕宽高比例值
          if (
            viewport.height > viewport.width ||
            viewport.width / viewport.height < screen.width / screen.height
          ) {
            //console.log(screen.height, viewport.height, viewport.width);
            const maxWidth = (screen.height / viewport.height) * viewport.width;
            //console.log(maxWidth);
            this.$refs.pdf.$el.style.width = `${
              maxWidth > screen.width ? screen.width : maxWidth
            }px`;
          }

          if (!screenfull.enabled) {
            return false;
          }

          // 切换全屏
          let el = document.querySelector(".pdf-wrap");
          screenfull.toggle(el);

          return;
        }
      });

      // let el = document.querySelector(".pdf-wrap");
      // if (!screenfull.enabled) {
      //   return false;
      // }
      // screenfull.toggle(el);

      //console.log(window.innerWidth);
      //this.$refs.pdf.$el.style.width = "500px";
      // this.$refs.pdf.$el.style.height = "500px";
    },
    // 开始一节事件
    handleFirstNode() {
      this.firstOrLast = undefined;
      this.dialogVisible = false;
      this.$emit("firstNode");
    },
    // 最后一节事件
    handleLastNode() {
      this.firstOrLast = undefined;
      this.dialogVisible = false;
      this.$emit("lastNode");
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
      if (!this.isFullscreen) {
        this.pageOriginalSize();
      }
    },
    init() {
      if (screenfull.enabled) {
        screenfull.on("change", this.change);
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off("change", this.change);
      }
    },
  },
};
</script>

<style>
.pdf-dialog .el-dialog__body {
  padding: 10px 20px !important;
}
</style>

<style scoped>
.full {
  position: fixed !important;
  z-index: 200;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100% !important;
}

.el-dialog:fullscreen {
}

/* Pdf */
.pdf-wrap {
  overflow-y: auto;
}

.pdf {
  display: inline-block;
  margin: 0 auto;
  /* height: 500px; */
}
.pdf .horizontal {
}
.pdf .vertical {
}

/* Pdf操作栏 */
.vue-pdf-embed {
  /* text-align: center; */
  width: 489px;
  /* border: 1px solid #e5e5e5; */
  margin: 0 auto;
  box-sizing: border-box;
}

.page-tool {
  /* position: absolute; */
  position: fixed;
  bottom: 35px;
  /* padding-left: 15px;
  padding-right: 15px; */
  display: flex;
  align-items: center;
  background: rgb(66, 66, 66, 0.5);
  color: white;
  border-radius: 19px;
  z-index: 100;
  cursor: pointer;
  /* margin-left: 50%; */
  /* transform: translateX(-50%); */
  justify-content: center;
}
.page-tool-item {
  padding: 8px 15px;
  /* padding-left: 10px; */
  cursor: pointer;
}

.page-tool-item a {
  color: #fff;
}

/* .page-tool-item:hover {
  background-color: #e5e5e5;
} */
.page-tool-item a:hover {
  /* background-color: #e5e5e5; */
  /* color: #000; */
  font-weight: 600;
}
</style>
